import React, { useContext } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { CustomerContext } from '../contexts/CustomerContext'
import useQueryString from '../hooks/use-query-string'

export const CartRequiredRoute = ({ path, exact, component: Component }) => {
  const { customer } = useContext(CustomerContext)
  const { app } = useQueryString()
  const cartKey = app ? 'apptCart' : 'cart'
  const hasCart = Boolean(customer['priorityCart'] || customer[cartKey])

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (hasCart ? <Component {...props} /> : <Redirect to="/" />)}
    />
  )
}

export const ApptCartRequiredRoute = ({ path, exact, component: Component }) => {
  const { customer: { apptCart } } = useContext(CustomerContext)
  const hasCart = Boolean(apptCart)

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => (hasCart ? <Component {...props} /> : <Redirect to="/" />)}
    />
  )
}

export function OrderPackageRequiredRoute({ path, exact, component: Component }) {
  const { customer: { currentOrderPackage } } = useContext(CustomerContext)

  return (
    <Route
      exact={exact}
      path={path}
      render={props => currentOrderPackage ? <Component {...props} /> : <Redirect to='/' />}
    />
  )
}

export function CurrentStudentRequiredRoute({ path, exact, component: Component }) {
  const { customer: { currentStudent } } = useContext(CustomerContext)

  return (
    <Route
      exact={exact}
      path={path}
      render={(props) => currentStudent ? <Component {...props} /> : <Redirect to='/' />}
    />
  )
}
